var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "bottom-bg"
  }), _c("TitleBar"), _vm._m(0), _c("div", {
    staticClass: "con"
  }, _vm._l(_vm.arr, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.showPop(item);
        }
      }
    }, [_c("div", {
      staticClass: "card"
    }, [_c("div", {
      staticClass: "name"
    }, [_c("span", [_vm._v("MG iSmart")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isTop,
        expression: "item.isTop"
      }],
      staticClass: "img",
      attrs: {
        src: require("../assets/images/Current.png"),
        alt: ""
      }
    }), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.isTop,
        expression: "!item.isTop"
      }],
      staticClass: "img",
      attrs: {
        src: require("../assets/images/Current-gray.png"),
        alt: ""
      }
    })]), _c("div", {
      staticClass: "type"
    }, [_vm._v(" MG EP21 1.5X ")]), _vm._m(1, true)]), _vm._m(2, true)]);
  }), 0), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShow,
      expression: "isShow"
    }],
    staticClass: "bg"
  }, [_c("div", {
    staticClass: "pop"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("span", [_vm._v("MG iSmart")]), _c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isGray,
      expression: "!isGray"
    }],
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Current.png"),
      alt: ""
    }
  }), _c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isGray,
      expression: "isGray"
    }],
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Current-gray.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "type"
  }, [_vm._v(" MG EP21 1.5X ")]), _vm._m(3), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isGray,
      expression: "!isGray"
    }],
    staticClass: "btn",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.unbind.apply(null, arguments);
      }
    }
  }, [_vm._v(" Unbund ")]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isGray,
      expression: "isGray"
    }],
    staticClass: "btn-wrap"
  }, [_c("span", {
    staticClass: "left",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.unbind.apply(null, arguments);
      }
    }
  }, [_vm._v("Unbund")]), _c("span", {
    staticClass: "right",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toSwitch.apply(null, arguments);
      }
    }
  }, [_vm._v("Switch")])])])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "greetings"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Vehicle")]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v("Management")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "detail"
  }, [_c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Oil")]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v("47%")])]), _c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Battery")]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v("76%")])]), _c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Battery Range")]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v("538km")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("img", {
    staticClass: "car-img",
    attrs: {
      src: require("../assets/images/Car_1.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "detail"
  }, [_c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v("Brand")]), _c("span", {
    staticClass: "right"
  }, [_vm._v("MG")])]), _c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v("Brand")]), _c("span", {
    staticClass: "right"
  }, [_vm._v("MG")])]), _c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v("Brand")]), _c("span", {
    staticClass: "right"
  }, [_vm._v("MG")])]), _c("div", {
    staticClass: "detail-item"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v("Brand")]), _c("span", {
    staticClass: "right"
  }, [_vm._v("MG")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };